import { API_URL, JWT_TOKEN } from "../../constants/appConfig";
import { getLocalStorage } from "./storage.utils";

export const getSignedUrl = async (uri, open = false) => {
  const token = getLocalStorage(JWT_TOKEN);
  const apiURL = `${API_URL}/graphql`;
  const response = await fetch(apiURL, {
    method: "POST",
    headers: {
      "x-auth-token": token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: `
            mutation($url: String!) {
              getSignedUrl(url: $url) {
                errors {
                  message
                }
                url
              }
            }
          `,
      variables: {
        url: uri,
      },
    }),
  }).then((res) => res.json());
  const tempData = response?.data?.getSignedUrl?.url;
  if (open) window.open(tempData, "_blank")?.focus();
  return tempData;
};

export const getSignedUrlForAccessToken = async (
  uri,
  accessToken,
  open = false
) => {
  const token = getLocalStorage(JWT_TOKEN);
  const apiURL = `${API_URL}/graphql`;
  const response = await fetch(apiURL, {
    method: "POST",
    headers: {
      "x-auth-token": token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: `
            mutation($accessToken: String!,$url: String!) {
              getSignedUrlForEstimateWithAccessToken(accessToken: $accessToken,url: $url) {
                errors {
                  message
                }
                url
              }
            }
          `,
      variables: {
        accessToken: accessToken,
        url: uri,
      },
    }),
  }).then((res) => res.json());
  const tempData = response?.data?.getSignedUrlForEstimateWithAccessToken?.url;
  if (open) window.open(tempData, "_blank")?.focus();
  return tempData;
};

export const getNameFromUrl = (name) => {
  if (name) {
    let nameArray = name?.split("name");
    let actualName = nameArray[1]?.split("?")[0];
    return actualName;
  }
  return "-";
};

export const capitalizeString = (input) => {
  return input.charAt(0).toUpperCase() + input.slice(1);
};
